import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'
import * as PortOne from "@portone/browser-sdk/v2";

/* 개발담당:이재호
 * 화면기능:카드등록창
 * 세부설명:
*/
export class RegisterCard extends Component {
    static displayName = RegisterCard.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.RegisterCardRef = React.createRef();
        this.uid = ""
        this.channelKey = ""
        this.storeId = ""
    }
    //초기화
    async componentDidMount() {
        let Data = await Big3Common.Get("api/Common/Common/GetUid");
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.uid = Data.message;
        }
        let Data2 = await Big3Common.Post("api/Common/Common/GetInfo", {});
        if (Data2.codeName === Big3Common.ResultCode.Success) {
            const info = JSON.parse(Data2.multiDataTable);
            this.channelKey = info.channelKey;
            this.storeId = info.storeId;
        }
    }
    async requestPayment() {
        try {
            const response = await PortOne.requestIssueBillingKey({
                storeId: this.storeId,
                channelKey: this.channelKey,
                billingKeyMethod: "CARD",
                issueId: this.uid,
                issueName: "클로디 카드등록",
                customer: {
                    customerId : this.uid
                },
                redirectUrl: window.location.origin + "/Success"
            });

            if (response.code) {
                window.location.href = window.location.origin + `/Fail?message=${response.message}`;
            }
            else {
                let Data = await Big3Common.Post("api/Common/Common/RegisterBillingKey", {
                    bill_key: response.billingKey
                }, true);

                if (Data.codeName === Big3Common.ResultCode.Success) {
                    // 전송 성공 시 리디렉션
                    window.location.href = window.location.origin + `/Success?billingKey=${response.billingKey}&transactionType=ISSUE_BILLING_KEY`;
                } else {
                    window.location.href = window.location.origin + `/Fail?message=${response.message}`;
                }
            }
            

        } catch (e) {
            console.log("handle_Charge: ", e);
        }
        return false;
    }

    render() {        
        return false;
    }
}
